import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CTABlock } from './CTABlock';
import { Lock, Smartphone, ShieldCheck, Crown } from 'lucide-react';
export function OfferStack() {
  return <section id="cart" className="bg-forest-900 py-20 px-4" data-id="element-71">
      <div className="max-w-2xl mx-auto" data-id="element-72">
        <div className="rounded-3xl shadow-2xl overflow-hidden border border-gold-400/30 bg-white" data-id="element-73">
          {/* Header */}
          <div className="bg-forest-900 text-gold-400 p-6 flex items-center justify-center gap-3 border-b-4 border-gold-500" data-id="element-74">
            <Crown className="w-8 h-8" data-id="element-75" />
            <h3 className="text-2xl md:text-3xl font-bold tracking-wide" data-id="element-76">
              Resumen de Todo lo que Recibís:
            </h3>
          </div>

          <div className="p-6 md:p-10" data-id="element-77">
            {/* Value Summary */}
            <div className="space-y-4 mb-10" data-id="element-78">
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-79">
                <span className="font-bold text-lg" data-id="element-80">
                  5 Tomos Protocolo Rescate SIBO™
                </span>
                <span className="font-bold text-lg" data-id="element-81">
                  <PriceDisplay amount={26950} data-id="element-82" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-83">
                <span className="font-medium" data-id="element-84">
                  Bono 01: Kit SOS Panza Globo
                </span>
                <span className="font-medium" data-id="element-85">
                  <PriceDisplay amount={2990} data-id="element-86" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-87">
                <span className="font-medium" data-id="element-88">Bono 02: Mapa de Compras</span>
                <span className="font-medium" data-id="element-89">
                  <PriceDisplay amount={1990} data-id="element-90" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-91">
                <span className="font-medium" data-id="element-92">Bono 03: Tracker 14 Días</span>
                <span className="font-medium" data-id="element-93">
                  <PriceDisplay amount={1990} data-id="element-94" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-95">
                <span className="font-medium" data-id="element-96">
                  Bono 04: Comer Afuera Sin Explotar
                </span>
                <span className="font-medium" data-id="element-97">
                  <PriceDisplay amount={1990} data-id="element-98" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-99">
                <span className="font-medium" data-id="element-100">
                  Bono 05: Ritual Nocturno 10/10
                </span>
                <span className="font-medium" data-id="element-101">
                  <PriceDisplay amount={1990} data-id="element-102" />
                </span>
              </div>
              <div className="flex justify-between items-center pt-4" data-id="element-103">
                <span className="text-xl font-bold text-forest-900" data-id="element-104">
                  VALOR TOTAL
                </span>
                <span className="text-xl font-bold text-forest-800/60 line-through" data-id="element-105">
                  <PriceDisplay amount={37900} data-id="element-106" />
                </span>
              </div>
              <div className="flex justify-between items-center bg-forest-50 p-6 rounded-2xl border border-forest-100 mt-6" data-id="element-107">
                <span className="text-xl md:text-2xl font-bold text-forest-900" data-id="element-108">
                  🔥 HOY PAGÁS SOLO
                </span>
                <span className="text-3xl md:text-4xl font-bold text-gold-500" data-id="element-109">
                  <PriceDisplay amount={19990} data-id="element-110" />
                </span>
              </div>
            </div>

            {/* Single CTA */}
            <CTABlock href="https://checkout.tumundoglobal.online/cart/45328607871167:1" className="w-full text-xl md:text-2xl py-5" data-id="element-111">
              ✅ ACCEDER AHORA — <PriceDisplay amount={19990} data-id="element-112" /> →
            </CTABlock>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-forest-800 font-medium mt-8" data-id="element-113">
              <div className="flex items-center gap-2" data-id="element-114">
                <Lock className="w-5 h-5 text-solution" data-id="element-115" />
                <span data-id="element-116">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-117">
                <Smartphone className="w-5 h-5 text-solution" data-id="element-118" />
                <span data-id="element-119">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-120">
                <ShieldCheck className="w-5 h-5 text-solution" data-id="element-121" />
                <span data-id="element-122">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}